import {FC} from 'react';
import clsx from 'clsx';
import Media from 'react-media';

import {useSelector} from '~/store/hooks';
import Icon from '~/common/Icon/Icon';
import {Icons} from '~/common/Icon';

import Dropdown from './parts/Dropdown';
import GuestMenu from './parts/GuestMenu';
import ProfileCard from './parts/ProfileCard';
import HeaderBalance from './parts/HeaderBalance';
import Notifications from '../Notifications/Notifications';
import s from './styles.module.scss';

interface HeaderMenuProps {
  className?: string;
  balance?: string;
  mail?: any;
  impersonate?: any;
  notifyButtonClassName?: string;
}

const HeaderMenu: FC<HeaderMenuProps> = ({
  className,
  mail,
  impersonate,
  balance,
  notifyButtonClassName,
}) => {
  const isGuest = useSelector(({profile}) => profile.isGuest);

  return (
    <div className={clsx(s.menu, className)}>
      {!isGuest && <Notifications buttonClassName={notifyButtonClassName} />}
      {impersonate && impersonate.display && (
        <div title={impersonate.email}>
          <svg className={s.menu__impersonate}>
            <use xlinkHref="/img/icons.svg#icon_impersonate" />
          </svg>
        </div>
      )}
      {balance && <HeaderBalance balance={balance} />}
      <Media query="(min-width: 425px)">
        {mail && mail.display && (
          <a className={s.menu__letter} href={mail.href}>
            <Icon name={Icons.headerEnvelope} className={s['menu__icon-envelope']} />
          </a>
        )}
      </Media>
      <Dropdown>{isGuest ? <GuestMenu /> : <ProfileCard />}</Dropdown>
    </div>
  );
};

export default HeaderMenu;
